import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { track } from "@/lib/track";
import { isStandalone } from "@/lib/pwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker (installability + push notifications).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("Service worker registration failed:", err));
  });
}

// Capture the Android/desktop install prompt as early as possible so the
// in-app install button can trigger it later.
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event("pwa-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event("pwa-installed"));
  // The OS-level install actually completing — distinct from the banner's
  // "prompt accepted", which can still fall through. The backend beacon below
  // already counts this for the admin metric; GA gets it too so installs can
  // be attributed to a source and compared against the banner funnel.
  track("app_installed", { platform: navigator.userAgent || undefined });
  // Best-effort server-side count for the admin PWA-install metric. Fire-and-
  // forget beacon (no auth, no response needed). Counts install events, which
  // is as close as the browser lets us get to "how many installed the app".
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/pwa/installed`;
    const body = JSON.stringify({ platform: navigator.userAgent || "" });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      });
    }
  } catch (e) {
    /* metric is best-effort */
  }
});

// One event per launch from the home screen, so installed-app usage is
// separable from web traffic in every report (GA4 otherwise can't tell them
// apart — a standalone launch looks like an ordinary direct visit).
if (isStandalone()) {
  track("app_launch_standalone");
}
